import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const modules = [
  {
    number: "01",
    title: "Seguridad Agéntica",
    description: "OWASP Top 10 para LLMs 2025 y Amazon Bedrock Guardrails",
    path: "/modulo-1",
    icon: "🛡️",
  },
  {
    number: "02",
    title: "AgentCore Runtime",
    description: "Despliega agentes LangGraph en la nube con aislamiento total",
    path: "/modulo-2",
    icon: "🚀",
  },
  {
    number: "03",
    title: "RAG - Knowledge Bases",
    description: "Retrieval Augmented Generation con Amazon Bedrock",
    path: "/modulo-3",
    icon: "📚",
  },
  {
    number: "04",
    title: "MCP Gateway",
    description: "AgentCore Gateway para gobernanza centralizada de herramientas",
    path: "/modulo-4",
    icon: "🔗",
  },
  {
    number: "05",
    title: "Memoria Agéntica",
    description: "Short Term y Long Term Memory con AgentCore Memory",
    path: "/modulo-5",
    icon: "🧠",
  },
  {
    number: "06",
    title: "Bonus - AgentCore Extras",
    description: "Registry, Observability, Identity y Policy",
    path: "/modulo-6",
    icon: "⭐",
  },
];

function Home() {
  return (
    <>
      <div className="bg-particles" />
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: "center", marginBottom: "60px" }}
        >
          <div style={{ marginBottom: "24px" }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/32/Nequi_Colombia_logo.svg"
              alt="Nequi"
              style={{ height: "40px", marginRight: "24px", filter: "brightness(0) invert(1)" }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
              alt="AWS"
              style={{ height: "36px", marginRight: "24px", filter: "brightness(0) invert(1)" }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <img
              src={process.env.PUBLIC_URL + "/pragma-logo.png"}
              alt="PRAGMA"
              style={{ height: "32px" }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
          <h1 className="module-title" style={{ fontSize: "3.5rem" }}>
            Workshop Agentic AI 2026
          </h1>
          <p className="module-description" style={{ fontSize: "1.3rem" }}>
            Construye agentes inteligentes con <strong style={{ color: "#DA0081" }}>Nequi</strong> y{" "}
            <strong style={{ color: "#FF9900" }}>Amazon Web Services</strong>. Desde seguridad hasta
            memoria persistente, domina cada primitiva de IA Agéntica.
          </p>
          <div style={{ marginTop: "32px", display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <span className="btn-primary" style={{ cursor: "default" }}>
              Nequito Agent 🤖
            </span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="motivational-banner"
        >
          <div className="motivational-banner-content">
            <span className="motivational-icon">🔥</span>
            <div>
              <h3 className="motivational-title">Cracks de Nequi: El Futuro es Agéntico</h3>
              <p className="motivational-text">
                En 2026, los agentes de IA ya no son demos — son la columna vertebral de experiencias reales.
                Ustedes están aquí construyendo lo que viene: agentes autónomos, seguros, con memoria y gobernanza.
                Nequi lidera la transformación digital en Colombia y ustedes son los arquitectos de ese futuro.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="motivational-banner motivational-banner-aws"
        >
          <div className="motivational-banner-content">
            <span className="motivational-icon">⚡</span>
            <div>
              <h3 className="motivational-title">La Evolución Agentic AI: Del Hoy al Mañana</h3>
              <p className="motivational-text">
                <strong>Hoy:</strong> Agentes con tools, RAG, guardrails y memoria contextual.{" "}
                <strong>Mañana:</strong> Flotas de agentes colaborativos, razonamiento multi-paso con verificación,
                y sistemas que aprenden de cada interacción. Con Amazon Bedrock AgentCore, cada primitiva que aprenden
                hoy es un building block del ecosistema agéntico del futuro.
              </p>
            </div>
          </div>
        </motion.div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: "24px", marginTop: "48px" }}>
          {modules.map((mod, i) => (
            <motion.div
              key={mod.number}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.8 + i * 0.1 }}
            >
              <Link to={mod.path} style={{ textDecoration: "none" }}>
                <div className="card" style={{ height: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                    <span style={{ fontSize: "2rem" }}>{mod.icon}</span>
                    <span style={{ fontSize: "0.75rem", fontWeight: "700", letterSpacing: "2px", color: "#FF9900" }}>
                      MÓDULO {mod.number}
                    </span>
                  </div>
                  <h3 style={{ fontSize: "1.4rem", fontWeight: "700", color: "#fff", marginBottom: "8px" }}>
                    {mod.title}
                  </h3>
                  <p style={{ color: "var(--text-secondary)", lineHeight: "1.6" }}>{mod.description}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.4 }}
          className="motivational-banner motivational-banner-future"
          style={{ marginTop: "48px" }}
        >
          <div className="motivational-banner-content">
            <span className="motivational-icon">🚀</span>
            <div>
              <h3 className="motivational-title">¡Nunca Paren de Aprender, Cracks!</h3>
              <p className="motivational-text">
                Cada línea de código que escriben hoy con AgentCore es una inversión en el futuro.
                Los agentes de IA van a transformar cómo Nequi sirve a millones de familias en Colombia.
                Ustedes son los pioneros. Construyan con confianza, experimenten sin miedo, y recuerden:
                el mejor agente es el que resuelve problemas reales para personas reales.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6 }}
          style={{ textAlign: "center", marginTop: "80px", padding: "40px", borderTop: "1px solid rgba(230,0,126,0.2)" }}
        >
          <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
            Workshop desarrollado por <strong style={{ color: "#DA0081" }}>Nequi</strong> en alianza con{" "}
            <strong style={{ color: "#FF9900" }}>Amazon Web Services</strong> | 2026
          </p>
        </motion.div>
      </div>
    </>
  );
}

export default Home;
